import React from "react";

const AppML_Messages = () => {
  return (
    <div className="tutorial-page">
      <h1>AppML Messages</h1>
      <p>This is the AppML Messages page content.</p>
    </div>
  );
};

export default AppML_Messages;
